export default "__VITE_ASSET__DJvVBOOF__"